import { render } from "./Advantages.vue?vue&type=template&id=50a37bd6"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__